export const CHECKOUT_SESSION_DATA=`CHECKOUT_SESSION_DATA`;
export const CHECKOUT_BRAND_DATA=`CHECKOUT_BRAND_DATA`;
export const ABANDONED_CART_DATA=`ABANDONED_CART_DATA`;
export const CUSTOMER_DATA=`CUSTOMER_DATA`;
export const PARTICIPANTS_DATA=`PARTICIPANTS_DATA`;
export const ADDON_DATA=`ADDON_DATA`;
export const DEPARTURE_SELECTED_DATA=`DEPARTURE_SELECTED_DATA`;
export const VARIATION_SELECTED_DATA=`VARIATION_SELECTED_DATA`;
export const PICKUPPOINT_SELECTED_DATA=`PICKUPPOINT_SELECTED_DATA`;
export const DISCOUNT_SELECTED_DATA=`DISCOUNT_SELECTED_DATA`;

/** Session backup for portal checkout invitation query (SPA route replaces strip the URL). */
export const SM_CHECKOUT_INVITATION_SESSION = `SM_CHECKOUT_INVITATION_SESSION`;

/*filter types */
export const HOME_WHERE_FILTER_TYPE=`HOME_WHERE_FILTER_TYPE`;
export const HOME_WHEN_FILTER_TYPE=`HOME_WHEN_FILTER_TYPE`;
export const HOME_TYPE_FILTER_TYPE=`HOME_TYPE_FILTER_TYPE`;
export const HOME_LEVEL_FILTER_TYPE=`HOME_LEVEL_FILTER_TYPE`;
export const HOME_LENGTH_FILTER_TYPE=`HOME_LENGTH_FILTER_TYPE`;
export const HOME_DATE_SELECT_FILTER_TYPE=`HOME_DATE_SELECT_FILTER_TYPE`;
export const HOME_DATE_CLEAR_FILTER_TYPE=`HOME_DATE_CLEAR_FILTER_TYPE`;